import { TextFieldProps } from "@mui/material";
import { RHFSelect } from "src/components/hook-form";
import { taxiReservationPassengerCountOptions } from "src/utils/app/taxiReservation";

type RHFSelectProps = TextFieldProps & {
  name: string;
  label: string;
};

export default function TaxiReservationPassengerCountSelect(props: RHFSelectProps) {
  return (
    <RHFSelect native {...props}>
      {taxiReservationPassengerCountOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </RHFSelect>
  );
}

